var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.isRule == true
      ? _c(
          "div",
          [
            _c("div", { staticClass: "page_box" }, [
              _c(
                "div",
                {
                  staticClass: "itemBox disWarp",
                  staticStyle: { width: "644px" },
                },
                [
                  _c("div", { staticClass: "bgBox" }, [
                    _c("img", {
                      staticClass: "itemBg",
                      attrs: {
                        src: require("../../assets/imgs/model1.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "itemBoxTitle" }, [
                      _vm._v("总下单用户数量"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(_vm._f("addComma")(_vm.statisticsData.customNum))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bgBox" }, [
                    _c("img", {
                      staticClass: "itemBg",
                      attrs: {
                        src: require("../../assets/imgs/model4.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "itemBoxTitle" }, [
                      _vm._v("总保安数量"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("addComma")(_vm.statisticsData.bodyguardNum)
                        )
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bgBox" }, [
                    _c("img", {
                      staticClass: "itemBg",
                      attrs: {
                        src: require("../../assets/imgs/model3.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "itemBoxTitle" }, [
                      _vm._v("总岗位次数"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(_vm._f("addComma")(_vm.statisticsData.workdNum))
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "bgBox" }, [
                    _c("img", {
                      staticClass: "itemBg",
                      attrs: {
                        src: require("../../assets/imgs/model2.png"),
                        alt: "",
                      },
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "itemBoxTitle" }, [
                      _vm._v("总发薪金额"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "num" }, [
                      _vm._v(
                        _vm._s(
                          _vm._f("moneyFormat")(_vm.statisticsData.totalMoney)
                        )
                      ),
                    ]),
                  ]),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox", staticStyle: { width: "644px" } },
                [
                  _c("div", { staticClass: "disBetween" }, [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "selectDate" },
                      _vm._l(_vm.selectDate, function (item, index) {
                        return _c(
                          "div",
                          {
                            class: [
                              "dateItem",
                              item.key == _vm.select ? "active" : "",
                            ],
                            on: {
                              click: function ($event) {
                                return _vm.dateSelect(item)
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.name) +
                                "\n            "
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "disWarp",
                      staticStyle: { "margin-top": "24px" },
                    },
                    [
                      _c("div", { staticClass: "overviewItem" }, [
                        _c("div", { staticClass: "overviewTitle" }, [
                          _vm._v("新增用户"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { margin: "10px 0" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("addComma")(
                                    _vm.overviewData.newCustomNum
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dis",
                            staticStyle: {
                              "font-size": "12px",
                              color: "#4e5969",
                            },
                          },
                          [
                            _c("div", { staticClass: "yesteday" }, [
                              _vm._v("昨日"),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("同比")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "rise" }, [
                              _vm._v(_vm._s(_vm.overviewData.newCustomYoy)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/rise.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "7px" } },
                              [_vm._v("环比")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "decline" }, [
                              _vm._v(_vm._s(_vm.overviewData.newCustomQoq)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/decline.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "overviewItem" }, [
                        _c("div", { staticClass: "overviewTitle" }, [
                          _vm._v("新增保安"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { margin: "10px 0" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("addComma")(
                                    _vm.overviewData.newBodyguardNum
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dis",
                            staticStyle: {
                              "font-size": "12px",
                              color: "#4e5969",
                            },
                          },
                          [
                            _c("div", { staticClass: "yesteday" }, [
                              _vm._v("昨日"),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("同比")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "rise" }, [
                              _vm._v(_vm._s(_vm.overviewData.newBodyguardYoy)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/rise.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "7px" } },
                              [_vm._v("环比")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "decline" }, [
                              _vm._v(_vm._s(_vm.overviewData.newBodyguardQoq)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/decline.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "overviewItem" }, [
                        _c("div", { staticClass: "overviewTitle" }, [
                          _vm._v("新增任务"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { margin: "10px 0" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("addComma")(_vm.overviewData.newJobNum)
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dis",
                            staticStyle: {
                              "font-size": "12px",
                              color: "#4e5969",
                            },
                          },
                          [
                            _c("div", { staticClass: "yesteday" }, [
                              _vm._v("昨日"),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("同比")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "rise" }, [
                              _vm._v(_vm._s(_vm.overviewData.newJobYoy)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/rise.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "7px" } },
                              [_vm._v("环比")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "decline" }, [
                              _vm._v(_vm._s(_vm.overviewData.newJobQoq)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/decline.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "overviewItem" }, [
                        _c("div", { staticClass: "overviewTitle" }, [
                          _vm._v("违约"),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "num",
                            staticStyle: { margin: "10px 0" },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(
                                  _vm._f("addComma")(
                                    _vm.overviewData.newViolateNum
                                  )
                                ) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "dis",
                            staticStyle: {
                              "font-size": "12px",
                              color: "#4e5969",
                            },
                          },
                          [
                            _c("div", { staticClass: "yesteday" }, [
                              _vm._v("昨日"),
                            ]),
                            _vm._v(" "),
                            _c("div", [_vm._v("同比")]),
                            _vm._v(" "),
                            _c("div", { staticClass: "rise" }, [
                              _vm._v(_vm._s(_vm.overviewData.newViolateYoy)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/rise.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticStyle: { "margin-left": "7px" } },
                              [_vm._v("环比")]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "decline" }, [
                              _vm._v(_vm._s(_vm.overviewData.newViolateQoq)),
                            ]),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "icon1",
                              attrs: {
                                src: require("../../assets/imgs/decline.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "100%" } },
                [
                  [
                    _c(
                      "el-tabs",
                      {
                        attrs: { type: "card" },
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "保安分布图", name: "first" } },
                          [
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  margin: "10px 0",
                                  display: "flex",
                                  "align-items": "center",
                                },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: {
                                      filterable: "",
                                      placeholder: "选择所属省份",
                                    },
                                    on: { change: _vm.selectCity },
                                    model: {
                                      value: _vm.cityCode,
                                      callback: function ($$v) {
                                        _vm.cityCode = $$v
                                      },
                                      expression: "cityCode",
                                    },
                                  },
                                  _vm._l(_vm.cityList, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: {
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "选择所属城市",
                                    },
                                    on: {
                                      clear: _vm.clearCity,
                                      change: _vm.selectCity1,
                                    },
                                    model: {
                                      value: _vm.cityCode1,
                                      callback: function ($$v) {
                                        _vm.cityCode1 = $$v
                                      },
                                      expression: "cityCode1",
                                    },
                                  },
                                  _vm._l(_vm.city1, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "130px",
                                    },
                                    attrs: {
                                      filterable: "",
                                      clearable: "",
                                      placeholder: "选择所属地区",
                                    },
                                    on: {
                                      clear: _vm.clearCity1,
                                      change: _vm.selectCity2,
                                    },
                                    model: {
                                      value: _vm.cityCode2,
                                      callback: function ($$v) {
                                        _vm.cityCode2 = $$v
                                      },
                                      expression: "cityCode2",
                                    },
                                  },
                                  _vm._l(_vm.city2, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.adcode,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "130px",
                                    },
                                    attrs: {
                                      placeholder: "选择证件",
                                      clearable: "",
                                    },
                                    on: {
                                      change: _vm.selectCertificate,
                                      clear: _vm.clearZhen,
                                    },
                                    model: {
                                      value: _vm.zhengjian,
                                      callback: function ($$v) {
                                        _vm.zhengjian = $$v
                                      },
                                      expression: "zhengjian",
                                    },
                                  },
                                  _vm._l(
                                    _vm.certificate,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: index,
                                        attrs: {
                                          label: item.title,
                                          value: item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-select",
                                  {
                                    staticStyle: {
                                      "margin-right": "auto",
                                      width: "150px",
                                    },
                                    attrs: {
                                      placeholder: "选择等级",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.level,
                                      callback: function ($$v) {
                                        _vm.level = $$v
                                      },
                                      expression: "level",
                                    },
                                  },
                                  _vm._l(_vm.ids, function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.propDesc,
                                        value: item.propValue,
                                      },
                                    })
                                  }),
                                  1
                                ),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "130px" },
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入姓名",
                                  },
                                  model: {
                                    value: _vm.articleName,
                                    callback: function ($$v) {
                                      _vm.articleName = $$v
                                    },
                                    expression: "articleName",
                                  },
                                }),
                                _vm._v(" "),
                                _c("el-input", {
                                  staticStyle: { width: "130px" },
                                  attrs: {
                                    maxlength: "50",
                                    clearable: "",
                                    placeholder: "请输入手机号",
                                  },
                                  model: {
                                    value: _vm.articlePhone,
                                    callback: function ($$v) {
                                      _vm.articlePhone = $$v
                                    },
                                    expression: "articlePhone",
                                  },
                                }),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    staticStyle: {
                                      display: "inline-block",
                                      "margin-left": "20px",
                                    },
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.serch()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetSearch()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.big()
                                      },
                                    },
                                  },
                                  [_vm._v("全屏")]
                                ),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { display: "flex" } }, [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "79%",
                                    "border-right": "1px solid #ccc",
                                  },
                                },
                                [
                                  _vm.showBaoan
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            position: "relative",
                                            width: "100%",
                                            height: "550px",
                                          },
                                          attrs: { id: "bigPage" },
                                        },
                                        [
                                          _vm.isFullscreen
                                            ? _c(
                                                "div",
                                                { staticClass: "mapSearch" },
                                                [
                                                  _vm.showDown
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "searchBox",
                                                          staticStyle: {
                                                            display: "flex",
                                                            "align-items":
                                                              "center",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "auto",
                                                                width: "150px",
                                                              },
                                                              attrs: {
                                                                "popper-append-to-body": false,
                                                                filterable: "",
                                                                placeholder:
                                                                  "选择所属省份",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.selectCity,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.cityCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.cityCode =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "cityCode",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.cityList,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        item.name,
                                                                      value:
                                                                        item.adcode,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "auto",
                                                                width: "150px",
                                                              },
                                                              attrs: {
                                                                "popper-append-to-body": false,
                                                                filterable: "",
                                                                clearable: "",
                                                                placeholder:
                                                                  "选择所属城市",
                                                              },
                                                              on: {
                                                                clear:
                                                                  _vm.clearCity,
                                                                change:
                                                                  _vm.selectCity1,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.cityCode1,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.cityCode1 =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "cityCode1",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.city1,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        item.name,
                                                                      value:
                                                                        item.adcode,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "auto",
                                                                width: "130px",
                                                              },
                                                              attrs: {
                                                                "popper-append-to-body": false,
                                                                filterable: "",
                                                                clearable: "",
                                                                placeholder:
                                                                  "选择所属地区",
                                                              },
                                                              on: {
                                                                clear:
                                                                  _vm.clearCity1,
                                                                change:
                                                                  _vm.selectCity2,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.cityCode2,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.cityCode2 =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "cityCode2",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.city2,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        item.name,
                                                                      value:
                                                                        item.adcode,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "auto",
                                                                width: "130px",
                                                              },
                                                              attrs: {
                                                                "popper-append-to-body": false,
                                                                placeholder:
                                                                  "选择证件",
                                                                clearable: "",
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.selectCertificate,
                                                                clear:
                                                                  _vm.clearZhen,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.zhengjian,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.zhengjian =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "zhengjian",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.certificate,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        item.title,
                                                                      value:
                                                                        item.id,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-select",
                                                            {
                                                              staticStyle: {
                                                                "margin-right":
                                                                  "auto",
                                                                width: "150px",
                                                              },
                                                              attrs: {
                                                                "popper-append-to-body": false,
                                                                placeholder:
                                                                  "选择等级",
                                                                clearable: "",
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.level,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.level =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "level",
                                                              },
                                                            },
                                                            _vm._l(
                                                              _vm.ids,
                                                              function (
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "el-option",
                                                                  {
                                                                    key: index,
                                                                    attrs: {
                                                                      label:
                                                                        item.propDesc,
                                                                      value:
                                                                        item.propValue,
                                                                    },
                                                                  }
                                                                )
                                                              }
                                                            ),
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width: "130px",
                                                            },
                                                            attrs: {
                                                              maxlength: "50",
                                                              clearable: "",
                                                              placeholder:
                                                                "请输入姓名",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.articleName,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.articleName =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "articleName",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("el-input", {
                                                            staticStyle: {
                                                              width: "130px",
                                                            },
                                                            attrs: {
                                                              maxlength: "50",
                                                              clearable: "",
                                                              placeholder:
                                                                "请输入手机号",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.articlePhone,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.articlePhone =
                                                                    $$v
                                                                },
                                                              expression:
                                                                "articlePhone",
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              staticStyle: {
                                                                display:
                                                                  "inline-block",
                                                                "margin-left":
                                                                  "20px",
                                                              },
                                                              attrs: {
                                                                type: "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.serch()
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("查询")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.resetSearch()
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("重置")]
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "el-button",
                                                            {
                                                              staticClass:
                                                                "btn",
                                                              attrs: {
                                                                type: "primary",
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.exitFullscreen()
                                                                  },
                                                              },
                                                            },
                                                            [_vm._v("退出全屏")]
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "text-align": "right",
                                                        "margin-right": "30px",
                                                      },
                                                    },
                                                    [
                                                      !_vm.showDown
                                                        ? _c("img", {
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "25px",
                                                            },
                                                            attrs: {
                                                              src: require("../../assets/imgs/down.png"),
                                                              alt: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.selectShow,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                      _vm._v(" "),
                                                      _vm.showDown
                                                        ? _c("img", {
                                                            staticStyle: {
                                                              width: "40px",
                                                              height: "25px",
                                                            },
                                                            attrs: {
                                                              src: require("../../assets/imgs/up.png"),
                                                              alt: "",
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.selectShow,
                                                            },
                                                          })
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        position: "absolute",
                                                        right: "0",
                                                        top: "20vh",
                                                        width: "21%",
                                                        display: "flex",
                                                        "align-items": "center",
                                                      },
                                                    },
                                                    [
                                                      _vm.showDown
                                                        ? _c(
                                                            "div",
                                                            {
                                                              staticStyle: {
                                                                background:
                                                                  "#fff",
                                                                "box-sizing":
                                                                  "border-box",
                                                                "font-weight":
                                                                  "600",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticStyle: {
                                                                    padding:
                                                                      "8px 0",
                                                                    "box-sizing":
                                                                      "border-box",
                                                                    background:
                                                                      "#165dff",
                                                                    color:
                                                                      "#fff",
                                                                  },
                                                                },
                                                                [
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "font-size":
                                                                            "16px",
                                                                          "font-weight":
                                                                            "600",
                                                                          "padding-left":
                                                                            "10px",
                                                                          "box-sizing":
                                                                            "border-box",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                              保安列表\n                            "
                                                                      ),
                                                                    ]
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          display:
                                                                            "flex",
                                                                          "align-items":
                                                                            "center",
                                                                          "padding-left":
                                                                            "10px",
                                                                          "box-sizing":
                                                                            "border-box",
                                                                        },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        [
                                                                          _vm._v(
                                                                            "地区：" +
                                                                              _vm._s(
                                                                                _vm.showAddress
                                                                              )
                                                                          ),
                                                                        ]
                                                                      ),
                                                                      _vm._v(
                                                                        " "
                                                                      ),
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticStyle:
                                                                            {
                                                                              "margin-left":
                                                                                "10px",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "\n                                人数：" +
                                                                              _vm._s(
                                                                                _vm.baoanTotal
                                                                              ) +
                                                                              "\n                              "
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  ),
                                                                ]
                                                              ),
                                                              _vm._v(" "),
                                                              _vm.baoanList
                                                                .length > 0
                                                                ? _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          height:
                                                                            "440px",
                                                                          "overflow-y":
                                                                            "scroll",
                                                                        },
                                                                    },
                                                                    _vm._l(
                                                                      _vm.baoanList,
                                                                      function (
                                                                        item,
                                                                        index
                                                                      ) {
                                                                        return _c(
                                                                          "div",
                                                                          {
                                                                            key: index,
                                                                            staticClass:
                                                                              "baoanItem",
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.seeItem(
                                                                                    item
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "div",
                                                                              {
                                                                                staticStyle:
                                                                                  {
                                                                                    "text-align":
                                                                                      "center",
                                                                                    "margin-right":
                                                                                      "6px",
                                                                                  },
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "img",
                                                                                  {
                                                                                    attrs:
                                                                                      {
                                                                                        src:
                                                                                          item.headimgUrl ||
                                                                                          require("@/assets/imgs/headImg.png"),
                                                                                        alt: "",
                                                                                      },
                                                                                  }
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "a",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        display:
                                                                                          "block",
                                                                                        width:
                                                                                          "50px",
                                                                                        "text-decoration":
                                                                                          "none",
                                                                                        height:
                                                                                          "20px",
                                                                                        "line-height":
                                                                                          "20px",
                                                                                        "text-align":
                                                                                          "center",
                                                                                        color:
                                                                                          "#fff",
                                                                                        background:
                                                                                          "#0091ff",
                                                                                        "border-radius":
                                                                                          "10px",
                                                                                        "margin-left":
                                                                                          "auto",
                                                                                        "font-size":
                                                                                          "10px",
                                                                                      },
                                                                                    attrs:
                                                                                      {
                                                                                        href:
                                                                                          "/askariDetail?id=" +
                                                                                          item.id,
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "查看更多"
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                            _vm._v(
                                                                              " "
                                                                            ),
                                                                            _c(
                                                                              "div",
                                                                              [
                                                                                _c(
                                                                                  "div",
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  " +
                                                                                        _vm._s(
                                                                                          item.accountType ==
                                                                                            0
                                                                                            ? item.companyName
                                                                                            : item.cardName
                                                                                        ) +
                                                                                        "(" +
                                                                                        _vm._s(
                                                                                          item.lastLoginCity
                                                                                        ) +
                                                                                        "-" +
                                                                                        _vm._s(
                                                                                          item.lastLoginArea
                                                                                        ) +
                                                                                        ")\n                                "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-size":
                                                                                          "10px",
                                                                                        margin:
                                                                                          "4px 0",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  最近登录时间：" +
                                                                                        _vm._s(
                                                                                          item.lastLoginTime
                                                                                        ) +
                                                                                        "\n                                "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                                _vm._v(
                                                                                  " "
                                                                                ),
                                                                                _c(
                                                                                  "div",
                                                                                  {
                                                                                    staticStyle:
                                                                                      {
                                                                                        "font-size":
                                                                                          "10px",
                                                                                      },
                                                                                  },
                                                                                  [
                                                                                    _vm._v(
                                                                                      "\n                                  最近登录地址：" +
                                                                                        _vm._s(
                                                                                          item.lastLoginAddress
                                                                                        ) +
                                                                                        "\n                                "
                                                                                    ),
                                                                                  ]
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        )
                                                                      }
                                                                    ),
                                                                    0
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(" "),
                                                              _vm.baoanList
                                                                .length > 0
                                                                ? _c(
                                                                    "el-pagination",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          margin:
                                                                            "20px 0 0",
                                                                        },
                                                                      attrs: {
                                                                        layout:
                                                                          "prev, pager, next",
                                                                        total:
                                                                          _vm.baoanTotal,
                                                                        small:
                                                                          "",
                                                                      },
                                                                      on: {
                                                                        "current-change":
                                                                          _vm.baoanHandleCurrentChange,
                                                                      },
                                                                    }
                                                                  )
                                                                : _c(
                                                                    "div",
                                                                    {
                                                                      staticStyle:
                                                                        {
                                                                          "text-align":
                                                                            "center",
                                                                          margin:
                                                                            "200px 0",
                                                                        },
                                                                    },
                                                                    [
                                                                      _vm._v(
                                                                        "\n                            暂无更多数据\n                          "
                                                                      ),
                                                                    ]
                                                                  ),
                                                            ],
                                                            1
                                                          )
                                                        : _vm._e(),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("div", {
                                            directives: [
                                              {
                                                name: "loading",
                                                rawName:
                                                  "v-loading.fullscreen.lock",
                                                value: _vm.mapLoading,
                                                expression: "mapLoading",
                                                modifiers: {
                                                  fullscreen: true,
                                                  lock: true,
                                                },
                                              },
                                            ],
                                            staticStyle: {
                                              width: "100%",
                                              height: "100%",
                                              "z-index": "99",
                                            },
                                            attrs: { id: "map" },
                                          }),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    width: "21%",
                                    "box-sizing": "border-box",
                                    "font-weight": "600",
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        padding: "8px 0",
                                        "box-sizing": "border-box",
                                        background: "#165dff",
                                        color: "#fff",
                                      },
                                    },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "font-size": "16px",
                                            "font-weight": "600",
                                            "padding-left": "10px",
                                            "box-sizing": "border-box",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                      保安列表\n                    "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            display: "flex",
                                            "align-items": "center",
                                            "padding-left": "10px",
                                            "box-sizing": "border-box",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _vm._v(
                                              "地区：" + _vm._s(_vm.showAddress)
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticStyle: {
                                                "margin-left": "10px",
                                              },
                                            },
                                            [
                                              _vm._v(
                                                "\n                        人数：" +
                                                  _vm._s(_vm.baoanTotal) +
                                                  "\n                      "
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.baoanList.length > 0
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            height: "440px",
                                            "overflow-y": "scroll",
                                          },
                                        },
                                        _vm._l(
                                          _vm.baoanList,
                                          function (item, index) {
                                            return _c(
                                              "div",
                                              {
                                                key: index,
                                                staticClass: "baoanItem",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.seeItem(item)
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "center",
                                                      "margin-right": "6px",
                                                    },
                                                  },
                                                  [
                                                    _c("img", {
                                                      attrs: {
                                                        src:
                                                          item.headimgUrl ||
                                                          require("@/assets/imgs/headImg.png"),
                                                        alt: "",
                                                      },
                                                    }),
                                                    _vm._v(" "),
                                                    _c(
                                                      "a",
                                                      {
                                                        staticStyle: {
                                                          display: "block",
                                                          width: "50px",
                                                          "text-decoration":
                                                            "none",
                                                          height: "20px",
                                                          "line-height": "20px",
                                                          "text-align":
                                                            "center",
                                                          color: "#fff",
                                                          background: "#0091ff",
                                                          "border-radius":
                                                            "10px",
                                                          "margin-left": "auto",
                                                          "font-size": "10px",
                                                        },
                                                        attrs: {
                                                          href:
                                                            "/askariDetail?id=" +
                                                            item.id,
                                                        },
                                                      },
                                                      [_vm._v("查看更多")]
                                                    ),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c("div", [
                                                  _c("div", [
                                                    _vm._v(
                                                      "\n                          " +
                                                        _vm._s(
                                                          item.accountType == 0
                                                            ? item.companyName
                                                            : item.cardName
                                                        ) +
                                                        "(" +
                                                        _vm._s(
                                                          item.lastLoginCity
                                                        ) +
                                                        "-" +
                                                        _vm._s(
                                                          item.lastLoginArea
                                                        ) +
                                                        ")\n                        "
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "10px",
                                                        margin: "4px 0",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          最近登录时间：" +
                                                          _vm._s(
                                                            item.lastLoginTime
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" "),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticStyle: {
                                                        "font-size": "10px",
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        "\n                          最近登录地址：" +
                                                          _vm._s(
                                                            item.lastLoginAddress
                                                          ) +
                                                          "\n                        "
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            )
                                          }
                                        ),
                                        0
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.baoanList.length > 0
                                    ? _c("el-pagination", {
                                        staticStyle: { margin: "20px 0 0" },
                                        attrs: {
                                          layout: "prev, pager, next",
                                          total: _vm.baoanTotal,
                                          small: "",
                                        },
                                        on: {
                                          "current-change":
                                            _vm.baoanHandleCurrentChange,
                                        },
                                      })
                                    : _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "text-align": "center",
                                            margin: "200px 0",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            "\n                    暂无更多数据\n                  "
                                          ),
                                        ]
                                      ),
                                ],
                                1
                              ),
                            ]),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tab-pane",
                          {
                            attrs: { label: "用户下单分布图", name: "second" },
                          },
                          [
                            _vm.showUser
                              ? _c("div", [
                                  _c("div", {
                                    staticStyle: {
                                      width: "100%",
                                      height: "500px",
                                    },
                                    attrs: { id: "map1" },
                                  }),
                                ])
                              : _vm._e(),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "邀请排名", name: "third" } },
                          [
                            [
                              _c(
                                "el-table",
                                {
                                  ref: "scrollTable",
                                  attrs: {
                                    data: _vm.rankingData,
                                    height: "302px",
                                    border: "",
                                  },
                                },
                                [
                                  _c("el-table-column", {
                                    attrs: { label: "排名" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.$index + 1)
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      4178052834
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: { prop: "cardName", label: "姓名" },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    scope.row.accountType == 0
                                                      ? scope.row.companyName
                                                      : scope.row.cardName
                                                  )
                                                ),
                                              ]),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      3364830297
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c("el-table-column", {
                                    attrs: {
                                      prop: "num",
                                      label: "邀请人数(点击可查看邀请人)",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (scope) {
                                            return [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "peopleNum",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.goAskair(
                                                        scope.row
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v(_vm._s(scope.row.num))]
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      false,
                                      2762935013
                                    ),
                                  }),
                                ],
                                1
                              ),
                            ],
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ],
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "644px" } },
                [
                  _c("div", { staticClass: "disBetween bgColor" }, [
                    _c("div", { staticClass: "dis" }, [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("../../assets/imgs/indexIcon.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "modelTitle" }, [
                        _vm._v("拦截任务"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pending" }, [
                        _vm._v("待处理: " + _vm._s(_vm.intercepttotalRows)),
                      ]),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm._l(_vm.regulationData, function (item, index) {
                    return item.type == 0
                      ? _c(
                          "div",
                          { key: index, staticClass: "dis bgColorTitle" },
                          [
                            _c("div", { staticClass: "titleItem dis" }, [
                              _c("div", { staticClass: "titleKey" }, [
                                _vm._v("发布人类型："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "titleval" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      item.publisherType == 0
                                        ? "所有"
                                        : item.publisherType == 1
                                        ? "个人"
                                        : "企业"
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "titleItem dis" }, [
                              _c("div", { staticClass: "titleKey" }, [
                                _vm._v("地区："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "titleval" }, [
                                _vm._v(_vm._s(item.cutRule.cityName)),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "titleItem dis" }, [
                              _c("div", { staticClass: "titleKey" }, [
                                _vm._v("总金额："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "titleval" }, [
                                _vm._v(
                                  "\n              ￥" +
                                    _vm._s(
                                      _vm._f("moneyFormat")(
                                        item.cutRule.moneyValue
                                      )
                                    ) +
                                    "以上\n            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "titleItem dis" }, [
                              _c("div", { staticClass: "titleKey" }, [
                                _vm._v("截停时间："),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "titleval" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm._f("maxTime")(
                                        item.cutRule.cutTimeValue
                                      )
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "indexBtn dis",
                                on: { click: _vm.goRegulation },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/imgs/setting.png"),
                                    alt: "",
                                  },
                                }),
                                _vm._v(" "),
                                _c("div", [_vm._v("设置规则")]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e()
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tableBorder" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.interceptData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              label: "倒计时",
                              width: "120",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("i", { staticClass: "el-icon-time" }),
                                      _vm._v(" "),
                                      _c(
                                        "span",
                                        {
                                          staticStyle: {
                                            "margin-left": "10px",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm._f("maxTime1")(
                                                scope.row.leaveTime
                                              )
                                            )
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              762933966
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "任务名称/城市/人数/要求",
                              width: "300",
                              align: "center",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            placement: "top",
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(scope.row.title) +
                                                "-" +
                                                _vm._s(scope.row.rangeName) +
                                                "-" +
                                                _vm._s(scope.row.readiesNum) +
                                                "/" +
                                                _vm._s(scope.row.membersNum) +
                                                "人-" +
                                                _vm._s(scope.row.high / 100) +
                                                "米-¥" +
                                                _vm._s(
                                                  scope.row.advancePayment
                                                ) +
                                                "\n                  "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "name-wrapper",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "omit" },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(scope.row.title) +
                                                      "-" +
                                                      _vm._s(
                                                        scope.row.rangeName
                                                      ) +
                                                      "-" +
                                                      _vm._s(
                                                        scope.row.readiesNum
                                                      ) +
                                                      "人-" +
                                                      _vm._s(
                                                        scope.row.high / 100
                                                      ) +
                                                      "米-¥" +
                                                      _vm._s(
                                                        scope.row.advancePayment
                                                      ) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              673356622
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "creatorName",
                              label: "发布人",
                              width: "80",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "disAround" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.stop(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    " +
                                                _vm._s(
                                                  scope.row.realActionAt != null
                                                    ? "暂停"
                                                    : "启动"
                                                ) +
                                                "\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.nowSend(scope.row, 3)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    立即发布\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(
                                                  scope.row,
                                                  3
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    派单\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3928748866
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "644px" } },
                [
                  _c("div", { staticClass: "disBetween bgColor" }, [
                    _c("div", { staticClass: "dis" }, [
                      _c("img", {
                        staticClass: "icon",
                        attrs: {
                          src: require("../../assets/imgs/indexIcon.png"),
                          alt: "",
                        },
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "modelTitle" }, [
                        _vm._v("违约待处理"),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "pending" }, [
                        _vm._v(
                          "待处理: " + _vm._s(_vm.waitdispatchlisttotalRows)
                        ),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "more",
                        on: {
                          click: function ($event) {
                            return _vm.selectMore(2)
                          },
                        },
                      },
                      [
                        _c("div", [_vm._v("查看更多")]),
                        _vm._v(" "),
                        _c("img", {
                          attrs: {
                            src: require("../../assets/imgs/more.png"),
                            alt: "",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "dis bgColorTitle tabelRight" }, [
                    _c(
                      "div",
                      {
                        staticClass: "indexBtn",
                        staticStyle: { "margin-right": "24px" },
                        on: { click: _vm.goViolation1 },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/imgs/setting.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("查看违约规则")]),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass: "indexBtn",
                        on: { click: _vm.goRegulation },
                      },
                      [
                        _c("img", {
                          attrs: {
                            src: require("../../assets/imgs/setting.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", [_vm._v("设置规则")]),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tableBorder" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.waitdispatchlistData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "violateLogNo",
                              label: "单号",
                              align: "center",
                              width: "150",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "任务名称", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            trigger: "hover",
                                            placement: "top",
                                            "popper-class": "popover",
                                          },
                                        },
                                        [
                                          _c("p", [
                                            _vm._v(_vm._s(scope.row.jobTitle)),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "name-wrapper",
                                              attrs: { slot: "reference" },
                                              slot: "reference",
                                            },
                                            [
                                              _c(
                                                "div",
                                                { staticClass: "omit" },
                                                [
                                                  _vm._v(
                                                    _vm._s(scope.row.jobTitle)
                                                  ),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              898602821
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "memberName",
                              label: "违约人",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "violateAt",
                              label: "违约时间",
                              align: "center",
                              width: "160",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "触发规则", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.withholdType == 2
                                        ? _c("span", [_vm._v("￥")])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.withholdNum)),
                                      ]),
                                      _vm._v(" "),
                                      scope.row.withholdType == 1
                                        ? _c("span", [_vm._v("%")])
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3303710142
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "违约金额", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              _vm._f("moneyFormat")(
                                                scope.row.violateAmount
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2080933858
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "违约状态",
                              align: "center",
                              width: "100",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.status == 0
                                        ? _c(
                                            "span",
                                            { staticClass: "yellowColor" },
                                            [_vm._v("待支付")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "greenColor" },
                                            [_vm._v("已支付")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              526287865
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              fixed: "right",
                              width: "120",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "disAround" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.goDetail(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    查看\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.memberType != 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "operateBtn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.handleEdit(
                                                      scope.row,
                                                      4
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    派单\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3612808079
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "disBetween bgColor",
                      staticStyle: {
                        background:
                          "linear-gradient(180deg, #eff5ff 0%, #ffffff 100%)",
                      },
                    },
                    [
                      _c("div", { staticClass: "dis" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../../assets/imgs/indexIcon.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v("派单列表"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pending" }, [
                          _vm._v(
                            "待处理: " + _vm._s(_vm.dispatchlisttotalRows)
                          ),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tabelRight" }, [
                        _c(
                          "div",
                          { staticClass: "titleItem dis" },
                          [
                            _c("div", { staticClass: "titleKey" }, [
                              _vm._v("显示结束时间："),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.regulationData, function (item, index) {
                              return item.type == 1
                                ? _c(
                                    "div",
                                    { key: index, staticClass: "titleval" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("maxTime")(
                                              item.dispatchRule
                                                .dispatchEndTimeValue
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "indexBtn",
                            on: { click: _vm.goRegulation },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/imgs/setting.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", [_vm._v("设置规则")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "solid" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.selectMore(3)
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v("查看更多")]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/imgs/more.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tableBorder" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.dispatchlistData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "creatorName",
                              label: "客户",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "title",
                              label: "任务名称",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "area",
                              label: "区域",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "要求人数", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          _vm._s(scope.row.readiesNum) +
                                            "/" +
                                            _vm._s(scope.row.membersNum)
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3323616490
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "距离结束时间", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c(
                                        "span",
                                        {
                                          class: [
                                            scope.row.selectTime < 0
                                              ? "redColor1"
                                              : "",
                                          ],
                                        },
                                        [
                                          scope.row.selectTime < 0
                                            ? _c("span", [_vm._v("-")])
                                            : _vm._e(),
                                          scope.row.day > 0
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.day) + "天"
                                                ),
                                              ])
                                            : _vm._e(),
                                          scope.row.hour1 > 0
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.hour1) +
                                                    "小时"
                                                ),
                                              ])
                                            : _vm._e(),
                                          scope.row.middle > 0
                                            ? _c("span", [
                                                _vm._v(
                                                  _vm._s(scope.row.middle) +
                                                    "分"
                                                ),
                                              ])
                                            : _vm._e(),
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(scope.row.theTime) + "秒"
                                            ),
                                          ]),
                                        ]
                                      ),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1969415673
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "总金额", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(
                                          "￥" +
                                            _vm._s(
                                              _vm._f("moneyFormat")(
                                                scope.row.price
                                              )
                                            )
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1281625071
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "加价", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v("￥" + _vm._s(scope.row.markUp)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1543605208
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              fixed: "right",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "disAround" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.goDetail1(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    查看\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit(
                                                  scope.row,
                                                  5
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    派单\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              934619813
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "disBetween bgColor",
                      staticStyle: {
                        background:
                          "linear-gradient(180deg, #eff5ff 0%, #ffffff 100%)",
                      },
                    },
                    [
                      _c("div", { staticClass: "dis" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../../assets/imgs/indexIcon.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v("回访超期"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pending" }, [
                          _vm._v("待处理: " + _vm._s(_vm.followuptotalRows)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tabelRight" }, [
                        _c(
                          "div",
                          { staticClass: "titleItem dis" },
                          [
                            _c("div", { staticClass: "titleKey" }, [
                              _vm._v("回访时间要求："),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.regulationData, function (item, index) {
                              return item.type == 2
                                ? _c(
                                    "div",
                                    { key: index, staticClass: "titleval" },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(
                                            _vm._f("maxTime")(
                                              item.followupRule
                                                .followupRequireTimeValue
                                            )
                                          ) +
                                          "\n              "
                                      ),
                                    ]
                                  )
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "indexBtn",
                            on: { click: _vm.goRegulation },
                          },
                          [
                            _c("img", {
                              attrs: {
                                src: require("../../assets/imgs/setting.png"),
                                alt: "",
                              },
                            }),
                            _vm._v(" "),
                            _c("div", [_vm._v("设置规则")]),
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "solid" }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.selectMore(4)
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v("查看更多")]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/imgs/more.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tableBorder" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.followupData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "customName",
                              label: "客户",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "任务名称", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.jobTitle)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3743276705
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "任务完成时间",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.jobCashAt)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              871939117
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "nickname",
                              label: "负责人",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "回访超期",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.wantCallAt)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              2280611997
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "状态", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      scope.row.status == 0
                                        ? _c(
                                            "span",
                                            { staticClass: "redColor" },
                                            [_vm._v("未完成")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 1
                                        ? _c(
                                            "span",
                                            { staticClass: "blueColor" },
                                            [_vm._v("回访中")]
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      scope.row.status == 2
                                        ? _c(
                                            "span",
                                            { staticClass: "greenColor" },
                                            [_vm._v("已完成")]
                                          )
                                        : _vm._e(),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1642397834
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "disAround" }, [
                                        scope.row.userId == "" ||
                                        scope.row.userId == null
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "operateBtn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.stop1(scope.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    分配\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        scope.row.userId != "" &&
                                        scope.row.userId != null
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "operateBtn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.stopData(
                                                      scope.row
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    取回\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.goDetail2(scope.row)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    查看\n                  "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        scope.row.status != 2
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "operateBtn",
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.set(scope.row)
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                    记录\n                  "
                                                ),
                                              ]
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              3432223522
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "itemBox1", staticStyle: { width: "100%" } },
                [
                  _c(
                    "div",
                    {
                      staticClass: "disBetween bgColor",
                      staticStyle: {
                        background:
                          "linear-gradient(180deg, #eff5ff 0%, #ffffff 100%)",
                      },
                    },
                    [
                      _c("div", { staticClass: "dis" }, [
                        _c("img", {
                          staticClass: "icon",
                          attrs: {
                            src: require("../../assets/imgs/indexIcon.png"),
                            alt: "",
                          },
                        }),
                        _vm._v(" "),
                        _c("div", { staticClass: "modelTitle" }, [
                          _vm._v("投诉处理"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "pending" }, [
                          _vm._v("待处理: " + _vm._s(_vm.complaintalRows)),
                        ]),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "tabelRight" }, [
                        _c(
                          "div",
                          {
                            staticClass: "more",
                            on: {
                              click: function ($event) {
                                return _vm.selectMore(5)
                              },
                            },
                          },
                          [
                            _c("div", [_vm._v("查看更多")]),
                            _vm._v(" "),
                            _c("img", {
                              attrs: {
                                src: require("../../assets/imgs/more.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                      ]),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "tableBorder" },
                    [
                      _c(
                        "el-table",
                        {
                          ref: "scrollTable",
                          staticStyle: { width: "100%" },
                          attrs: { data: _vm.complainData },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              prop: "id",
                              label: "单号",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "任务名称", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.jobName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              906615718
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "投诉人",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.customName)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1681415122
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "bodyguardName",
                              label: "投诉对象",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "投诉内容",
                              align: "center",
                              width: "160",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.complainMemo)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1431612279
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: { label: "投诉时间", align: "center" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("span", [
                                        _vm._v(_vm._s(scope.row.submitAt)),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              993468455
                            ),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              align: "center",
                              width: "180",
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "default",
                                  fn: function (scope) {
                                    return [
                                      _c("div", { staticClass: "disAround" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "operateBtn",
                                            on: {
                                              click: function ($event) {
                                                return _vm.handleEdit1(
                                                  scope.row
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                    处理\n                  "
                                            ),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  },
                                },
                              ],
                              null,
                              false,
                              1145561349
                            ),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticStyle: { width: "100%" } }, [
                _c("div", { staticClass: "recommendation" }, [
                  _vm._v("意见反馈"),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "tabBox" },
                  [
                    _c(
                      "el-table",
                      {
                        ref: "scrollTable",
                        staticStyle: { width: "100%" },
                        attrs: { data: _vm.recommendation1 },
                      },
                      [
                        _c("el-table-column", {
                          attrs: { label: "账号类型", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _vm._v(
                                      "\n                " +
                                        _vm._s(
                                          scope.row.type == 1 ? "用户" : "保安"
                                        ) +
                                        "\n              "
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            812080346
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "accountPhone",
                            label: "联系方式",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "content",
                            label: "投诉与建议",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            label: "图片",
                            align: "center",
                            width: "300",
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        staticStyle: {
                                          display: "flex",
                                          "flex-wrap": "wrap",
                                          "justify-content": "center",
                                        },
                                      },
                                      _vm._l(
                                        scope.row.img,
                                        function (item, index) {
                                          return item
                                            ? _c("el-image", {
                                                key: index,
                                                staticStyle: {
                                                  width: "50px",
                                                  height: "50px",
                                                  "margin-left": "10px",
                                                },
                                                attrs: {
                                                  src: item,
                                                  alt: "",
                                                  "preview-src-list":
                                                    scope.row.img,
                                                },
                                              })
                                            : _vm._e()
                                        }
                                      ),
                                      1
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            1229385267
                          ),
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "gmtCreate",
                            label: "创建时间",
                            align: "center",
                          },
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { label: "操作", align: "center" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (scope) {
                                  return undefined
                                },
                              },
                            ],
                            null,
                            false,
                            4154174436
                          ),
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "派单设置",
                  visible: _vm.dialogFormVisible1,
                  width: "800px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogFormVisible1 = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm2 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 4 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入名称" },
                                  on: { focus: _vm.clearData },
                                  model: {
                                    value: _vm.ruleForm2.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm2, "name", $$v)
                                    },
                                    expression: "ruleForm2.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入手机号" },
                                  on: { focus: _vm.clearData },
                                  model: {
                                    value: _vm.ruleForm2.phone,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm2, "phone", $$v)
                                    },
                                    expression: "ruleForm2.phone",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "身份状态" } },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "请选择" },
                                    model: {
                                      value: _vm.ruleForm2.status,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.ruleForm2, "status", $$v)
                                      },
                                      expression: "ruleForm2.status",
                                    },
                                  },
                                  _vm._l(_vm.tableData, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 4 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUserList()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm1()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                  _vm._v(
                    "\n        需求人数：" +
                      _vm._s(_vm.selectData.membersNum) +
                      "，已参与人数：" +
                      _vm._s(_vm.selectData.readiesNum) +
                      "\n      "
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticStyle: { "margin-bottom": "20px" } }, [
                  _vm._v("搜索总数：" + _vm._s(_vm.tableData1.length)),
                ]),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData1,
                      "highlight-current-row": "",
                      "max-height": "250",
                    },
                    on: { "current-change": _vm.selectItem },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _c("div", {
                                  class: [
                                    scope.row.id == _vm.selectUserID
                                      ? "select"
                                      : "noselect",
                                  ],
                                }),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        2681964027
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "姓名" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.accountType == 0
                                      ? scope.row.companyName
                                      : scope.row.cardName
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        3196743394
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "类型" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                _vm._v(
                                  _vm._s(
                                    scope.row.accountType == 0
                                      ? "企业"
                                      : scope.row.accountType == 1
                                      ? "企业员工"
                                      : "临勤"
                                  )
                                ),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        938447953
                      ),
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "30px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.allocation()
                          },
                        },
                      },
                      [_vm._v("派单")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.resetForm2()
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "回访记录设置",
                  visible: _vm.dialogFormVisible,
                  width: "600px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogFormVisible = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  {
                    ref: "ruleForm",
                    staticStyle: { margin: "0 auto" },
                    attrs: {
                      "label-position": "right",
                      model: _vm.ruleForm1,
                      rules: _vm.rules,
                    },
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "反馈内容", prop: "content" } },
                      [
                        _c("el-input", {
                          staticStyle: { width: "280px" },
                          attrs: { type: "textarea", placeholder: "请输入" },
                          model: {
                            value: _vm.ruleForm1.content,
                            callback: function ($$v) {
                              _vm.$set(_vm.ruleForm1, "content", $$v)
                            },
                            expression: "ruleForm1.content",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "", prop: "" } },
                      [
                        _c(
                          "el-radio-group",
                          {
                            model: {
                              value: _vm.ruleForm1.select,
                              callback: function ($$v) {
                                _vm.$set(_vm.ruleForm1, "select", $$v)
                              },
                              expression: "ruleForm1.select",
                            },
                          },
                          [
                            _c("el-radio", { attrs: { label: "1" } }, [
                              _vm._v("需再次回访"),
                            ]),
                            _vm._v(" "),
                            _c("el-radio", { attrs: { label: "2" } }, [
                              _vm._v("完结回访"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      [
                        _c(
                          "el-button",
                          {
                            on: {
                              click: function ($event) {
                                return _vm.resetForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("取消")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.submitForm("ruleForm")
                              },
                            },
                          },
                          [_vm._v("确定")]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "el-dialog",
              {
                attrs: {
                  title: "分配设置",
                  visible: _vm.dialogFormVisible2,
                  width: "800px",
                },
                on: {
                  "update:visible": function ($event) {
                    _vm.dialogFormVisible2 = $event
                  },
                },
              },
              [
                _c(
                  "el-form",
                  { ref: "ruleForm", attrs: { model: _vm.ruleForm3 } },
                  [
                    _c(
                      "el-row",
                      { attrs: { gutter: 4 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "请输入名称/手机号" },
                                  model: {
                                    value: _vm.ruleForm3.name,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.ruleForm3, "name", $$v)
                                    },
                                    expression: "ruleForm3.name",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 10 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "部门" } },
                              [
                                _c("el-cascader", {
                                  attrs: {
                                    value: _vm.ruleForm3.status,
                                    props: _vm.cateProps,
                                    "show-all-levels": false,
                                    options: _vm.tableData3,
                                  },
                                  on: { change: _vm.handleChange },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 8 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticClass: "btn",
                                    attrs: { type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.getUserList1()
                                      },
                                    },
                                  },
                                  [_vm._v("查询")]
                                ),
                                _vm._v(" "),
                                _c(
                                  "el-button",
                                  {
                                    on: {
                                      click: function ($event) {
                                        return _vm.resetForm4()
                                      },
                                    },
                                  },
                                  [_vm._v("重置")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "el-table",
                  {
                    ref: "singleTable",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.tableData2,
                      "highlight-current-row": "",
                      "max-height": "250",
                    },
                    on: { "current-change": _vm.selectItem3 },
                  },
                  [
                    _c("el-table-column", {
                      attrs: { align: "center", width: "50" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [
                                scope.row.id == _vm.selectUser1.id
                                  ? _c("div", { staticClass: "select" })
                                  : _vm._e(),
                              ]
                            },
                          },
                        ],
                        null,
                        false,
                        574986569
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { label: "部门" },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "default",
                            fn: function (scope) {
                              return [_vm._v(_vm._s(scope.row.divisionName))]
                            },
                          },
                        ],
                        null,
                        false,
                        4231235635
                      ),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "name", label: "姓名" },
                    }),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      "margin-top": "30px",
                      "text-align": "right",
                    },
                  },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn",
                        attrs: { type: "primary" },
                        on: {
                          click: function ($event) {
                            return _vm.allocation1()
                          },
                        },
                      },
                      [_vm._v("分配")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.resetForm3()
                          },
                        },
                      },
                      [_vm._v("取消")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      {
        staticStyle: {
          width: "650px",
          height: "500px",
          position: "fixed",
          top: "20%",
          left: "25%",
        },
        style: {
          display: _vm.showModel == true ? "block" : "none",
          background: _vm.callType == "shipin" ? "" : "#ccc",
        },
        attrs: { id: "local-video" },
      },
      [
        _vm.showBtn
          ? _c(
              "div",
              {
                staticStyle: {
                  display: "flex",
                  "align-items": "center",
                  "justify-content": "space-evenly",
                  position: "absolute",
                  bottom: "20px",
                  left: "0",
                  color: "#fff",
                  width: "100%",
                  "z-index": "99",
                },
              },
              [
                _c(
                  "div",
                  {
                    staticStyle: { "text-align": "center", cursor: "pointer" },
                    on: { click: _vm.closeYin },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "30px",
                          height: "30px",
                          background: "#fff",
                          "text-align": "center",
                          "line-height": "30px",
                          "border-radius": "100%",
                          margin: "0 auto 5px",
                        },
                      },
                      [
                        _vm.isOpen
                          ? _c(
                              "svg",
                              {
                                staticStyle: {
                                  width: "20px",
                                  height: "30px",
                                  "margin-top": "-6px",
                                  "margin-left": "4px",
                                },
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 34 13",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M2.58 14.496c.167 0 .304.136.304.303a9.637 9.637 0 0 0 9.638 9.639 9.637 9.637 0 0 0 9.639-9.639c0-.167.136-.303.303-.303h2.277c.167 0 .304.136.304.303 0 6.455-4.884 11.767-11.157 12.45v3.867h5.666c.52 0 .937.543.937 1.214v1.366c0 .167-.106.304-.235.304H4.789c-.13 0-.235-.137-.235-.304V32.33c0-.671.417-1.214.937-1.214h5.513V27.23C4.804 26.483 0 21.2 0 14.8c0-.168.137-.304.304-.304ZM12.522 0c3.563 0 6.451 2.854 6.451 6.375v8.5c0 3.521-2.888 6.375-6.45 6.375-3.564 0-6.452-2.854-6.452-6.375v-8.5C6.071 2.854 8.96 0 12.522 0Z",
                                    "fill-rule": "nonzero",
                                    fill: "#363B4D",
                                    "data-follow-fill": "#363B4D",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        !_vm.isOpen
                          ? _c(
                              "svg",
                              {
                                staticStyle: {
                                  width: "20px",
                                  height: "20px",
                                  "margin-top": "6px",
                                },
                                attrs: {
                                  xmlns: "http://www.w3.org/2000/svg",
                                  viewBox: "0 0 26 34",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    d: "M2.58 14.496c.167 0 .304.136.304.303a9.637 9.637 0 0 0 9.638 9.639c1.02 0 2.004-.159 2.927-.453l2.229 2.23c-1.177.532-2.452.889-3.79 1.034v3.867h5.666c.52 0 .937.543.937 1.214v1.366c0 .167-.106.304-.235.304H4.789c-.13 0-.235-.137-.235-.304V32.33c0-.671.417-1.214.937-1.214h5.513V27.23C4.804 26.483 0 21.2 0 14.8c0-.168.137-.304.304-.304H2.58Zm.202-8.835 21.92 21.92a1.5 1.5 0 0 1-2.12 2.122L.661 7.783a1.5 1.5 0 0 1 2.12-2.122Zm21.96 8.835c.166 0 .303.136.303.303 0 3.251-1.24 6.213-3.271 8.439l-2.041-2.042a9.602 9.602 0 0 0 2.428-6.397c0-.167.136-.303.303-.303h2.277Zm-18.671.111 6.64 6.64a6.65 6.65 0 0 1-.189.003c-3.563 0-6.45-2.854-6.45-6.375l-.001-.268ZM12.522 0c3.563 0 6.451 2.854 6.451 6.375v8.5c0 1.55-.559 2.97-1.488 4.074L6.07 7.535v-1.16C6.071 2.854 8.96 0 12.522 0Z",
                                    "fill-rule": "nonzero",
                                    fill: "#000",
                                    "data-follow-fill": "#FFF",
                                  },
                                }),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [
                      _vm._v(
                        _vm._s(_vm.isOpen == true ? "麦克风已开" : "麦克风已关")
                      ),
                    ]),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: { "text-align": "center", cursor: "pointer" },
                    on: { click: _vm.closeModel },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          width: "30px",
                          height: "30px",
                          background: "red",
                          "text-align": "center",
                          "line-height": "30px",
                          "border-radius": "100%",
                          "margin-bottom": "5px",
                        },
                      },
                      [
                        _c(
                          "svg",
                          {
                            staticStyle: { width: "15px", height: "8px" },
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 34 13",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M33.05 4.075C30.75 1.521 25.24 0 18.322 0L15.76.01C8.834.01 3.312 1.522.974 4.076l-.091.11C-.561 5.937-.035 9.58 1.04 11.15c.679 1.011 1.379.985 1.68.9 2.374-.432 6.05-1.584 7.05-2.387l.068-.058.044-.078c.367-.608.276-1.258.187-1.812-.12-.744-.146-1.197.371-1.663.148-.139 1.005-.607 5.528-.66h1.944c4.616.043 5.492.509 5.653.66.528.48.47.916.354 1.656-.095.57-.2 1.206.161 1.817l.048.08.068.056c.987.8 4.655 1.959 6.958 2.373.315.104.926.138 1.557-.628 1.291-1.54 1.948-5.523.339-7.33Z",
                                "fill-rule": "nonzero",
                                fill: "#fff",
                                "data-follow-fill": "#FFF",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", [_vm._v("挂断")]),
                  ]
                ),
              ]
            )
          : _vm._e(),
      ]
    ),
    _vm._v(" "),
    _vm.isRule == false
      ? _c("div", [
          _c("div", { staticClass: "bigText" }, [
            _vm._v("欢迎使用咖德保安运营平台"),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "dis" }, [
      _c("img", {
        staticClass: "icon",
        attrs: { src: require("../../assets/imgs/indexIcon.png"), alt: "" },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "modelTitle" }, [_vm._v("经营概况")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }